import { lazy } from 'react';

export const ShiftDistributionPage = lazy(() => import('./ShiftDistributionPage'));
